import { defineStore } from "pinia";

export const useTeamStore = defineStore('team', {
    state: () => ({
        team: {},
        teams: [],
        selectTeams: [],
    }),
    actions: {
        setTeam(team) {
            this.team = team
        },
        setTeams(teams) {
            this.teams = teams
        },
        setSelectTeams(selectTeams) {
            this.selectTeams = selectTeams
        },
        addTeam(team) {
            this.teams.unshift(team)
        },
        updateTeam(team) {
            let index = this.teams.findIndex(cl => cl.id === team.id)
            this.teams.splice(index, 1, team)
        },
        deleteTeam(team) {
            let index = this.teams.findIndex(cl => cl.id === team.id)
            this.teams.splice(index, 1)
        },
    },
});